import { render, staticRenderFns } from "./Journalism.vue?vue&type=template&id=024a6c69&scoped=true&"
import script from "./Journalism.vue?vue&type=script&lang=js&"
export * from "./Journalism.vue?vue&type=script&lang=js&"
import style0 from "./Journalism.vue?vue&type=style&index=0&id=024a6c69&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a6c69",
  null
  
)

export default component.exports